import React from 'react';
import Loadable from 'react-loadable';
import { Redirect, Route, Switch } from 'react-router-dom';

import EditableRoute from '@components/EditableRoute';
import { AppraisalRoute } from './constants';
import AppraisalPageWrapper from './components/PageWrapper';
import PropertyDetailsView from './pages/propertyDetails/PropertyDetailsView';

const Loading = () => <div />;

const AppraisalBuilderPlanCreate = Loadable({
  loader: () => import('./pages/builderPlanCreate'),
  loading: Loading,
});

const AppraisalBuilderPlanDetail = Loadable({
  loader: () => import('./pages/builderPlanDetail'),
  loading: Loading,
});

const AppraisalBuilderPlansSearch = Loadable({
  loader: () => import('./pages/builderPlansSearch'),
  loading: Loading,
});

const AppraisalDashboard = Loadable({
  loader: () => import('./pages/dashboardExecute'),
  loading: Loading,
});

const AppraisalDashboardQuery = Loadable({
  loader: () => import('./pages/dashboardExecute/components/QueryResultsTable'),
  loading: Loading,
});

const AppraisalDeedDetail = Loadable({
  loader: () => import('./pages/deedDetailItem'),
  loading: Loading,
});

const AppraisalDeedsSearch = Loadable({
  loader: () => import('./pages/deedSearch'),
  loading: Loading,
});

const AppraisalMobileHomeSearch = Loadable({
  loader: () => import('./pages/mobileHomeSearch'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestSearchTaxpayer = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestTaxpayer'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestDetailTaxpayer = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestDetailTaxpayer'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestNewTaxpayer = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestDetailTaxpayer'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestSearchAgent = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestAgent'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestDetailAgent = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestDetailAgent'),
  loading: Loading,
});

const AppraisalElectronicDeliveryRequestNewAgent = Loadable({
  loader: () => import('./pages/electronicDeliveryRequestDetailAgent'),
  loading: Loading,
});

const AppraisalIncomingCalls = Loadable({
  loader: () => import('./pages/incomingCalls'),
  loading: Loading,
});

const AppraisalEvaluation = Loadable({
  loader: () => import('./pages/evaluation'),
  loading: Loading,
});

const AppraisalPropertySearch = Loadable({
  loader: () => import('./pages/propertySearch'),
  loading: Loading,
});

const AppraisalPropertyEquitySearch = Loadable({
  loader: () => import('./pages/propertyEquitySearch'),
  loading: Loading,
});

const AppraisalPropertySmartGroupsSearch = Loadable({
  loader: () => import('./pages/propertySmartGroupsSearch'),
  loading: Loading,
});

const AppraisalPropertySmartGroup = Loadable({
  loader: () => import('./pages/propertySmartGroupDetail'),
  loading: Loading,
});

const AppraisalPropertyPage = Loadable({
  loader: () => import('./pages/propertyPage'),
  loading: Loading,
});
const AppraisalPropertyMassCreate = Loadable({
  loader: () => import('./pages/propertyMassCreate'),
  loading: Loading,
});
const AppraisalPropertyTransfer = Loadable({
  loader: () => import('./pages/ownershipTransfer'),
  loading: Loading,
});
const AppraisalMassCreateProperties = Loadable({
  loader: () => import('./pages/propertyMassCreate/propertyListing'),
  loading: Loading,
});
const AppraisalPropertyMassCreateWalkthrough = Loadable({
  loader: () => import('./pages/propertyMassCreate/walkThrough'),
  loading: Loading,
});
const AppraisalPropertyCreateWalkthrough = Loadable({
  loader: () => import('./pages/propertyCreate/walkThrough'),
  loading: Loading,
});

const AppealCreateWalkthrough = Loadable({
  loader: () => import('./pages/appealCreate/walkThrough'),
  loading: Loading,
});

const AppraisalOwner = Loadable({
  loader: () => import('./pages/owner'),
  loading: Loading,
});
const AppraisalOwnerSearch = Loadable({
  loader: () => import('./pages/ownerSearch'),
  loading: Loading,
});
const AppraisalOwnerDetail = Loadable({
  loader: () => import('./pages/ownerDetail'),
  loading: Loading,
});

const AppraisalAgentSearch = Loadable({
  loader: () => import('./pages/agentSearch'),
  loading: Loading,
});
const AppraisalAgentDetail = Loadable({
  loader: () => import('./pages/agentDetail'),
  loading: Loading,
});
const AppraisalAgentMassEntry = Loadable({
  loader: () => import('./pages/agentMassEntry'),
  loading: Loading,
});
const AppraisalMortgagelenderSearch = Loadable({
  loader: () => import('./pages/mortgagelenderSearch'),
  loading: Loading,
});
const AppraisalMortgagelenderDetail = Loadable({
  loader: () => import('./pages/mortgagelenderDetail'),
  loading: Loading,
});
const AppraisalMortgagelenderDetailItem = Loadable({
  loader: () => import('./pages/mortgagelenderDetailItem'),
  loading: Loading,
});
const AppraisalPropertyAgentDetail = Loadable({
  loader: () => import('./pages/agentSummary/propertyAgentDetail'),
  loading: Loading,
});

const AppraisalPropertyAgentFiduciary = Loadable({
  loader: () => import('./pages/agentSummary/propertyAgentFiduciary'),
  loading: Loading,
});

const AppraisalPropertyAgentBetaDetail = Loadable({
  loader: () => import('./pages/agentSummaryBeta/propertyAgentDetail'),
  loading: Loading,
});

const AppraisalPropertyAgentBetaFiduciary = Loadable({
  loader: () => import('./pages/agentSummaryBeta/propertyAgentFiduciary'),
  loading: Loading,
});

const AppraisalPropertyMerge = Loadable({
  loader: () => import('./pages/propertyMerge'),
  loading: Loading,
});

const AppraisalPropertySplit = Loadable({
  loader: () => import('./pages/propertySplit'),
  loading: Loading,
});

const AppraisalRenditionWalkthrough = Loadable({
  loader: () => import('./pages/renditionWalkthrough'),
  loading: Loading,
});

const AppraisalBPPRenditionWalkthrough = Loadable({
  loader: () => import('./pages/bppRenditionWalkthrough'),
  loading: Loading,
});

const AppraisalMenuProfileDefaults = Loadable({
  loader: () => import('@modules/appraisal/pages/menuprofileDefaults'),
  loading: Loading,
});

const AppraisalMenuProfileDefaultAdd = Loadable({
  loader: () => import('@modules/appraisal/pages/menuprofileDefaults/addNew'),
  loading: Loading,
});

const AppraisalMenuProfileDefaultEdit = Loadable({
  loader: () => import('@modules/appraisal/pages/menuprofileDefaults/edit'),
  loading: Loading,
});

const AppraisalExemptionWalkthru = Loadable({
  loader: () => import('./pages/exemptionWalkthrough'),
  loading: Loading,
});

const AppraisalSaleSearch = Loadable({
  loader: () => import('./pages/saleSearch'),
  loading: Loading,
});
const AppraisalSaleDetail = Loadable({
  loader: () => import('./pages/saleDetail'),
  loading: Loading,
});

const AppraisalBuildingPermitsSearch = Loadable({
  loader: () => import('./pages/buildingPermitsSearch'),
  loading: Loading,
});

const AppraisalMassRematchListing = Loadable({
  loader: () =>
    import('./pages/buildingPermitsSearch/components/MassRematchListing'),
  loading: Loading,
});

const AppraisalBuildingPermits = Loadable({
  loader: () =>
    import(
      './pages/propertyPage/widgetTypes/buildingPermitsDisplay/components/buildingPermits'
    ),
  loading: Loading,
});

const AppraisalEconomicUnitsSearch = Loadable({
  loader: () => import('./pages/economicUnitSearch'),
  loading: Loading,
});

const AppraisalEconomicUnitCreate = Loadable({
  loader: () => import('./pages/economicUnitCreate'),
  loading: Loading,
});

const AppraisalEconomicUnitDetail = Loadable({
  loader: () => import('./pages/economicUnitDetail'),
  loading: Loading,
});

const AppraisalPropertyMap = Loadable({
  loader: () => import('./pages/propertyMap'),
  loading: Loading,
});

const AppraisalSalesSearchMap = Loadable({
  loader: () => import('./pages/salesSearchMap'),
  loading: Loading,
});

const AppraisalSmartLists = Loadable({
  loader: () => import('./pages/smartListLauncher'),
  loading: Loading,
});

const AppraisalSmartListDisplay = Loadable({
  loader: () => import('./pages/smartListLauncher/smartListDisplay'),
  loading: Loading,
});

const AppraisalDetailPlatDocumentView = Loadable({
  loader: () => import('./pages/viewPlat/detailPlatView'),
  loading: Loading,
});

const AppraisalMassImportValuations = Loadable({
  loader: () => import('./pages/massImportValuation'),
  loading: Loading,
});

const AgentPropertyCount = Loadable({
  loader: () => import('./pages/agentPropertyCount'),
  loading: () => null,
});

const AppraisalRoutes = () => (
  <Switch>
    <Route
      component={AppraisalSmartListDisplay}
      exact
      path={AppraisalRoute.AppraisalSmartListDisplay}
    />
    <Route
      path="/appraisal"
      render={(props) => (
        <AppraisalPageWrapper {...props}>
          <Switch>
            <Route
              component={AppraisalBuilderPlanCreate}
              exact
              path={AppraisalRoute.AppraisalBuilderPlanCreate}
            />
            <EditableRoute
              component={AppraisalBuilderPlanDetail}
              exact
              path={AppraisalRoute.AppraisalBuilderPlanDetail}
            />
            <Route
              component={AppraisalBuilderPlansSearch}
              exact
              path={AppraisalRoute.AppraisalBuilderPlansSearch}
            />
            <Route
              component={AppraisalPropertyTransfer}
              exact
              path={AppraisalRoute.AppraisalPropertyTransfer}
            />
            <Route
              component={AppraisalEvaluation}
              exact
              path={AppraisalRoute.AppraisalEvaluation}
            />
            <Route
              component={AppraisalDashboard}
              exact
              path={AppraisalRoute.AppraisalDashboard}
            />
            <Route
              component={AppraisalDashboardQuery}
              exact
              path={AppraisalRoute.AppraisalDashboardQuery}
            />
            <Route
              component={AppraisalMassCreateProperties}
              path={AppraisalRoute.AppraisalMassCreateProperties}
            />
            <Route
              component={AppraisalPropertyMassCreateWalkthrough}
              path={AppraisalRoute.AppraisalPropertyEditWalkthrough}
            />
            <Route
              component={AppraisalPropertyCreateWalkthrough}
              path={AppraisalRoute.AppraisalPropertyCreateWalkthrough}
            />
            <Route
              component={AppealCreateWalkthrough}
              path={AppraisalRoute.AppealCreateWalkthrough}
            />
            <Route
              component={AppraisalPropertyMassCreateWalkthrough}
              path={AppraisalRoute.AppraisalPropertyMassCreateWalkthrough}
            />
            <Route
              component={AppraisalPropertyMassCreate}
              path={AppraisalRoute.AppraisalPropertyMassCreate}
            />
            <Route
              component={AppraisalPropertyMerge}
              path={AppraisalRoute.AppraisalPropertyMerge}
            />
            <Route
              component={AppraisalPropertySplit}
              path={AppraisalRoute.AppraisalPropertySplit}
            />
            <Route
              component={AppraisalRenditionWalkthrough}
              path={AppraisalRoute.AppraisalRenditionWalkthrough}
            />
            <Route
              component={AppraisalBPPRenditionWalkthrough}
              path={AppraisalRoute.AppraisalBPPRenditionWalkthrough}
            />
            <Route
              component={AppraisalExemptionWalkthru}
              path={AppraisalRoute.AppraisalExemptionWalkthru}
            />
            <Route
              component={AppraisalPropertySearch}
              exact
              path={AppraisalRoute.AppraisalPropertySearch}
            />
            <Route
              component={AppraisalPropertyEquitySearch}
              exact
              path={AppraisalRoute.AppraisalPropertyEquitySearch}
            />
            <Route
              component={AppraisalPropertyPage}
              path={AppraisalRoute.AppraisalPropertyPage}
            />
            <Route
              component={AppraisalOwner}
              exact
              path={AppraisalRoute.AppraisalOwner}
            />
            <Route
              component={AppraisalOwnerSearch}
              exact
              path={AppraisalRoute.AppraisalOwnerSearch}
            />
            <Route
              component={AppraisalOwnerDetail}
              exact
              path={AppraisalRoute.AppraisalOwnerCreate}
            />
            <EditableRoute
              component={AppraisalOwnerDetail}
              exact
              path={AppraisalRoute.AppraisalOwnerDetail}
            />
            <Route
              component={AppraisalAgentSearch}
              exact
              path={AppraisalRoute.AppraisalAgentSearch}
            />
            <Route
              component={AppraisalAgentDetail}
              exact
              path={AppraisalRoute.AppraisalAgentCreate}
            />
            <Route
              component={AppraisalAgentMassEntry}
              exact
              path={AppraisalRoute.AppraisalAgentMassEntryWalkthrough}
            />
            <EditableRoute
              component={AppraisalAgentDetail}
              exact
              path={AppraisalRoute.AppraisalAgentDetail}
            />
            <EditableRoute
              component={AppraisalDeedDetail}
              exact
              path={AppraisalRoute.AppraisalDeedDetail}
            />
            <Route
              component={AppraisalDeedsSearch}
              exact
              path={AppraisalRoute.AppraisalDeedsSearch}
            />
            <Route
              component={AppraisalMobileHomeSearch}
              exact
              path={AppraisalRoute.AppraisalMobileHomeSearch}
            />
            <Route
              component={AppraisalElectronicDeliveryRequestSearchTaxpayer}
              exact
              path={
                AppraisalRoute.AppraisalElectronicDeliveryRequestSearchTaxpayer
              }
            />
            <Route
              component={AppraisalElectronicDeliveryRequestDetailTaxpayer}
              exact
              path={
                AppraisalRoute.AppraisalElectronicDeliveryRequestDetailTaxpayer
              }
            />
            <Route
              component={AppraisalElectronicDeliveryRequestNewTaxpayer}
              exact
              path={
                AppraisalRoute.AppraisalElectronicDeliveryRequestNewTaxpayer
              }
            />
            <Route
              component={AppraisalElectronicDeliveryRequestSearchAgent}
              exact
              path={
                AppraisalRoute.AppraisalElectronicDeliveryRequestSearchAgent
              }
            />
            <Route
              component={AppraisalElectronicDeliveryRequestDetailAgent}
              exact
              path={
                AppraisalRoute.AppraisalElectronicDeliveryRequestDetailAgent
              }
            />
            <Route
              component={AppraisalElectronicDeliveryRequestNewAgent}
              exact
              path={AppraisalRoute.AppraisalElectronicDeliveryRequestNewAgent}
            />
            <Route
              component={AppraisalIncomingCalls}
              exact
              path={AppraisalRoute.AppraisalIncomingCalls}
            />
            <Route
              component={AppraisalPropertyAgentDetail}
              exact
              path={AppraisalRoute.AppraisalPropertyAgentDetail}
            />
            <Route
              component={AppraisalPropertyAgentFiduciary}
              exact
              path={AppraisalRoute.AppraisalPropertyAgentFiduciary}
            />
            <Route
              component={AppraisalPropertyAgentBetaDetail}
              exact
              path={AppraisalRoute.AppraisalPropertyAgentBetaDetail}
            />
            <Route
              component={AppraisalPropertyAgentBetaFiduciary}
              exact
              path={AppraisalRoute.AppraisalPropertyAgentBetaFiduciary}
            />
            <EditableRoute
              component={AppraisalPropertySmartGroup}
              exact
              path={AppraisalRoute.AppraisalPropertySmartGroup}
            />
            <Route
              component={AppraisalPropertySmartGroupsSearch}
              exact
              path={AppraisalRoute.AppraisalPropertySmartGroupsSearch}
            />
            <Route
              component={AppraisalMortgagelenderSearch}
              exact
              path={AppraisalRoute.AppraisalMortgagelenderSearch}
            />
            <Route
              component={AppraisalMortgagelenderDetail}
              exact
              path={AppraisalRoute.AppraisalMortgagelenderCreate}
            />
            <EditableRoute
              component={AppraisalMortgagelenderDetailItem}
              exact
              path={AppraisalRoute.AppraisalMortgagelenderDetail}
            />
            <Route
              component={AppraisalMenuProfileDefaults}
              exact
              path={AppraisalRoute.AppraisalMenuProfileDefaults}
            />
            <Route
              component={AppraisalMenuProfileDefaultAdd}
              exact
              path={AppraisalRoute.AppraisalMenuProfileDefaultAdd}
            />
            <Route
              component={AppraisalMenuProfileDefaultEdit}
              exact
              path={AppraisalRoute.AppraisalMenuProfileDefaultEdit}
            />
            <Route
              component={AppraisalSaleSearch}
              exact
              path={AppraisalRoute.AppraisalSaleSearch}
            />
            <EditableRoute
              component={AppraisalSaleDetail}
              exact
              path={AppraisalRoute.AppraisalSaleDetail}
            />
            <Route
              component={AppraisalBuildingPermitsSearch}
              exact
              path={AppraisalRoute.AppraisalBuildingPermitsSearch}
            />
            <Route
              component={AppraisalMassRematchListing}
              exact
              path={AppraisalRoute.AppraisalMassRematchListing}
            />
            <EditableRoute
              component={AppraisalBuildingPermits}
              exact
              path={AppraisalRoute.AppraisalBuildingPermits}
            />
            <Route
              component={AppraisalEconomicUnitsSearch}
              exact
              path={AppraisalRoute.AppraisalEconomicUnitsSearch}
            />
            <Route
              component={AppraisalEconomicUnitCreate}
              exact
              path={AppraisalRoute.AppraisalEconomicUnitCreate}
            />
            <EditableRoute
              component={AppraisalEconomicUnitDetail}
              exact
              path={AppraisalRoute.AppraisalEconomicUnitDetail}
            />
            <Route
              component={AppraisalSmartLists}
              exact
              path={AppraisalRoute.AppraisalSmartLists}
            />
            <Route
              component={AppraisalPropertyMap}
              exact
              path={AppraisalRoute.AppraisalPropertyMap}
            />
            <Route
              component={AppraisalSalesSearchMap}
              exact
              path={AppraisalRoute.AppraisalSalesSearchMap}
            />
            <Route
              component={AppraisalDetailPlatDocumentView}
              exact
              path={AppraisalRoute.AppraisalDetailPlatDocumentView}
            />
            <Route
              component={AppraisalMassImportValuations}
              exact
              path={AppraisalRoute.AppraisalMassImportValuations}
            />
            <Route
              exact
              path={AppraisalRoute.AppraisalAgentPropertyCount}
              component={AgentPropertyCount}
            />
            <Route
              path="/appraisal/notice/:noticeId/properties"
              component={PropertyDetailsView}
            />
            <Redirect to={AppraisalRoute.AppraisalPropertySearch} />
          </Switch>
        </AppraisalPageWrapper>
      )}
    />
  </Switch>
);

export default AppraisalRoutes;
